function dateHasPassed(dateString) {
  const dateToCheck = Date.parse(dateString);
  const dateToday = Date.now();
  return dateToCheck < dateToday;
}

export default dateHasPassed;
